import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'

let routesReady = false
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/login' && (to.query.from === 'sunny-logout' || to.query.intent === 'password')) {
    next(); NProgress.done(); return
  }
  if (!getToken()) {
    next(to.path === '/login' ? undefined : {path:'/login',query:to.path === '/sunny-password' ? {intent:'password',user:to.query.user} : {}})
    NProgress.done(); return
  }
  // Resolve the server's policy before rendering any original business layout, including old sessions.
  store.dispatch('GetInfo').then(res => {
    if (res.data.sunnyRestricted) {
      if (to.path === '/sunny-password') next()
      else { window.location.replace('/newadmin/'); NProgress.done() }
      return
    }
    if (to.path === '/login') { next({path:'/'}); return }
    if (to.path === '/sunny-password') { next({path:'/'}); return }
    store.dispatch('GenerateRoutes', {menus:res.data.menus,username:res.data.username}).then(() => {
      if (!routesReady) {
        router.addRoutes(store.getters.addRouters)
        routesReady = true
        next({...to,replace:true})
      } else next()
    })
  }).catch(() => {
    store.dispatch('FedLogOut').then(() => {
      Message.error('请重新登录')
      next({path:'/login',query:to.path === '/sunny-password' ? {intent:'password',user:to.query.user} : {}})
    })
  })
})
router.afterEach(() => NProgress.done())



// WEBPACK FOOTER //
// ./src/permission.js